import { useState } from 'react';

import { Button, CheckBox, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import styles from './AgreeDirectDebitMandateModal.module.css';

type TProps = {
    onClose: () => void;
    isModalOpen: boolean;
};

export const AgreeDirectDebitMandateModal = ({
    onClose,
    isModalOpen
}: TProps) => {
    const [directDebitAgreed, setDirectDebitModalAgreed] = useState(false);

    const handleAgreeCheckBoxClick = (checked: boolean) => {
        setDirectDebitModalAgreed(checked);
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={onClose}
            closeIcon={true}
            headerBar={true}
            title={
                <FormattedMessage
                    id="_.modal.agree_direct_debit_mandate.title"
                    defaultMessage="SEPA Core Direct Debit Mandate"
                />
            }
        >
            <div className={styles.AgreeDirectDebitMandateModal}>
                <div className={styles.agreementText}>
                    <>
                        <p className={styles.copyParagraph}>
                            {`Ich ermächtige iwoca Management S.à.r.l.
                            (Gläubiger-ID: LU72ZZZ0000000000000001848) und
                            Stripe Payments Europe Ltd., unseren
                            Zahlungsdienstleister, Zahlungen von meinem oben
                            angegebenen Konto mittels Lastschrift einzuziehen.
                            Zugleich weise ich mein Kreditinstitut an, die von
                            Stripe Payments Europe Ltd. im Auftrag von iwoca
                            Management S.à.r.l. auf mein Konto gezogenen
                            Lastschriften einzulösen.`}
                        </p>
                        <br />
                        <p
                            className={styles.copyParagraph}
                        >{`Weiterhin erkläre ich mich damit einverstanden, die
                            Vorabankündigung bis spätestens 3 Tage vor
                            Zahlungseinzug zu erhalten. Meine Rechte kann ich
                            den Bedingungen meines Kreditinstituts entnehmen.`}</p>
                        <br />
                        <p className={styles.copyParagraph}>
                            {`Hinweis: Ich kann innerhalb von acht Wochen,
                                beginnend mit dem Belastungsdatum, die Erstattung
                                des belasteten Betrages verlangen. Es gelten dabei
                                die mit meinem Kreditinstitut vereinbarten
                                Bedingungen.`}
                        </p>
                        <br />
                        <p
                            className={styles.copyParagraph}
                            data-testid="stripe-link-information-sentence"
                        >
                            Für mehr Informationen lesen Sie gern auch den{' '}
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://stripe.com/en-gb-de/privacy#translation"
                                className={styles.copyLink}
                            >
                                Datenschutzhinweis
                            </a>{' '}
                            von Stripe.
                        </p>
                    </>
                </div>
                <div>
                    <form
                        data-testid="direct-debit-mandate-form"
                        className={styles.agreeDirectDebitMandateForm}
                    >
                        <div className={styles.checkboxWrapper}>
                            <CheckBox
                                name="directDebitMandate"
                                required
                                aria-label="agree"
                                onChange={(e) =>
                                    handleAgreeCheckBoxClick(e.target.checked)
                                }
                            />
                            <label htmlFor="directDebitMandate">
                                <FormattedMessage
                                    id="_.modal.agree_direct_debit_mandate.checkboxMessage"
                                    defaultMessage="I have read and understood the SEPA Direct Debit Mandate and hereby give my consent to the recurring debit."
                                />
                            </label>
                        </div>
                        <div className={styles.buttonWrapper}>
                            <Button
                                type="submit"
                                disabled={!directDebitAgreed}
                                className={styles.submitButton}
                            >
                                <FormattedMessage
                                    id="_.modal.agree_direct_debit_mandate.submit"
                                    defaultMessage="Submit"
                                />
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};
